// let tag = document.createElement('script');
// tag.src = 'https://player.vimeo.com/api/player.js';
// document.getElementsByTagName('head')[0].appendChild(tag);

window.addEventListener('load', function () {

	var swiper;
	// var videos;
	// var videoObj=[];
	function slider(){
		if (window.innerWidth <= 1007) {
		if($('.swiper-slide').length <= 1){
			var noswipe = true;
		}else{
			var noswipe = false;
		}
		var centered = true;
			swiper = new Swiper('#swiper', {
				speed: 800,
				spaceBetween: 10,
				loop: true,
				slidesPerView: 1,
				centeredSlides: centered,
				autoplay: false,
				noSwiping: noswipe,
				noSwipingClass: 'swiper-slide',
				keyboard: {
					onlyInViewport: false,
				},
				// navigation: {
				// 	nextEl: '.swiper_next',
				// 	prevEl: '.swiper_prev',
				// },
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
				},
			});
		}
	}
	slider();

	function showLink (){
		$('#swiper').on('click', function(){
			$(this).toggleClass('showlink');
		})
	}
	showLink();
	
	var swState;
	var _swState;
	function initSwiper() {
		if (window.innerWidth <= 1007) {
			_swState = 0;
		} else {
			_swState = 1;
		}
		if(swState != _swState){
			if(swiper){
				swiper.destroy();
			}
			slider();
			swState = _swState;
		}
	}
	var timer;
	window.addEventListener('resize', function () {
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(initSwiper, 200);
	});
	initSwiper();
	
});


